<app-toast [message]="toast.message"></app-toast>

<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <app-loading [condition]="isLoading"></app-loading>
    @if (!isLoading) {
      <div class="card border-0">
        <h4 class="card-header border-0">Notifications</h4>
        <div class="card-body">
          @if (!notifications?.length) {
            <div class="col mb-3 px-0">
              There are no notifications to show.
            </div>
          }
          <button class="btn btn-success mb-4" (click)="markAllAsRead()">
            <i class="fa fa-check"></i> Mark all as read
          </button>
          @for (notification of notifications; track notification) {
            <div class="col mb-3 px-0">
              <div class="card h-100">
                <div class="card-body" [ngClass]="{ 'opacity-50': notification.read }">
                  <div class="d-flex flex-row">
                    @if (notification.type === 'comment') {
                      <h5 class="card-title m-0">
                        <i class="fa fa-comments"></i>
                        <a (click)="goToLink(notification)" [routerLink]="">
                          New {{notification.type}} on "{{notification._record?.title}}" record
                        </a>
                      </h5>
                    }
                    @if (notification.type === 'record') {
                      <h5 class="card-title m-0">
                        <i class="fa fa-list"></i>
                        <a (click)="goToLink(notification)" [routerLink]="">
                          You were added to "{{notification._record?.title}}" {{notification.type}}
                        </a>
                      </h5>
                    }
                    <div class="ms-2">
                      on {{notification.date | date:'medium'}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>